import { React, useState } from "react";
import { Form, FloatingLabel } from "react-bootstrap";
import "./login.css";
import { Link, useNavigate } from "react-router-dom";

function Login({ setIsLoggedIn }) {
  const [userDetails, setUserDetails] = useState({
    userId: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();

  const [err, setErr] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserDetails({ ...userDetails, [name]: value });
  };

  const handleHRLogin = (e) => {
    e.preventDefault();

    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    if (userDetails.userId === "admin@gmail.com" && userDetails.password === "2025") {
        navigate("/");
        localStorage.setItem("isLoggedIn", true);
        window.location.reload()
    } else {
        setErr("Invalid Credentials");
    }
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <div className="login-main-container">
        <div className="login-container">
          <div className="login-form">
            <div className="login-heading">
              <h2>Log In</h2>
            </div>
            <div>
              <div className="invalid-deets text-start">{err}</div>
              <Form noValidate validated={validated} onSubmit={handleHRLogin}>
                <div className="row">
                  <div className="col-12 col-sm-12 col-lg-12 mb-5">
                    <Form.Group controlId="exampleForm.ControlInput1">
                      <FloatingLabel
                        controlId="floatingInput"
                        label="Email ID"
                        className="mb-3"
                      >
                        <Form.Control
                          type="email"
                          required
                          placeholder="name@example.com"
                          name="userId"
                          value={userDetails.userId}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          className="text-start"
                        >
                          Please provide Email Id.
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Form.Group>
                  </div>
                  <div className="col-12 col-sm-12 col-lg-12 mb-5 showPassword">
                    <FloatingLabel
                      controlId="floatingPassword"
                      label="Password"
                    >
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        required
                        placeholder="Password"
                        name="password"
                        value={userDetails.password}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback
                        type="invalid"
                        className="text-start"
                      >
                        Please provide Password.
                      </Form.Control.Feedback>
                    </FloatingLabel>
                    {userDetails.password ? (
                      <div onClick={handleShowPassword}>
                        {/* <img
                          className="showPasswordImg"
                          width="18px"
                          src={eyeImg}
                          alt="img"
                        /> */}
                        {showPassword ? (
                          <div className="fwd-slash"></div>
                        ) : (
                          <></>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="login-btn">
                  <button>Login</button>
                </div>
              </Form>
            </div>
          </div>
        </div>
        <div className="login-greeting d-flex flex-column gap-5">
          <h1>Welcome Back!</h1>
          <h4>
            To keep connected with us please login with your personal info
          </h4>
        </div>
      </div>
    </div>
  );
}

export default Login;
